import { clampStudyDay } from '../constants'
import { resolveProjectionDayCap } from '../projectionDayCap'

/** @returns {{ freq?: string, interval: number, count: number|null }} */
export const parseSimpleRrule = rruleStr => {
  if (!rruleStr || typeof rruleStr !== 'string') {
    return { interval: 1, count: null }
  }
  const parts = {}
  rruleStr.split(';').forEach(pair => {
    const idx = pair.indexOf('=')
    if (idx === -1) return
    const key = pair.slice(0, idx).trim().toUpperCase()
    const value = pair.slice(idx + 1).trim()
    if (key) parts[key] = value
  })
  const intervalRaw = Number(parts.INTERVAL)
  const countRaw = Number(parts.COUNT)
  return {
    freq: parts.FREQ ? String(parts.FREQ).toUpperCase() : undefined,
    interval: Number.isFinite(intervalRaw) && intervalRaw > 0 ? Math.floor(intervalRaw) : 1,
    count: Number.isFinite(countRaw) && countRaw > 0 ? Math.floor(countRaw) : null,
  }
}

const dayStepForFreq = (freq, interval) => {
  const step = interval > 0 ? interval : 1
  if (freq === 'DAILY' || !freq) return step
  if (freq === 'WEEKLY') return step * 7
  return null
}

const resolveSeriesCap = (start, studyEndDay, seriesEndStudyDay) => {
  let cap = resolveProjectionDayCap(studyEndDay)
  if (seriesEndStudyDay != null && Number.isFinite(Number(seriesEndStudyDay))) {
    const end = Math.floor(Number(seriesEndStudyDay))
    if (end >= start) cap = Math.min(cap, end)
  }
  return cap
}

/** Expand supported RRULE modes to study days, capped at projection day limit. */
export const expandRruleStudyDays = (
  firstStudyDay,
  repeat,
  studyEndDay,
  endRuleCount = null,
  seriesEndStudyDay = null,
) => {
  const start = clampStudyDay(firstStudyDay)
  const cap = resolveSeriesCap(start, studyEndDay, seriesEndStudyDay)
  const parsed = parseSimpleRrule(repeat?.rrule)
  let count = repeat?.count ?? repeat?.recurrences ?? parsed.count
  if (count != null && endRuleCount != null) count = Math.min(count, endRuleCount)
  else if (count == null && endRuleCount != null) count = endRuleCount
  const dayStep = dayStepForFreq(parsed.freq, parsed.interval)

  if (dayStep == null) return [start]

  if (count != null && count > 0) {
    const days = []
    for (let i = 0; i < count; i += 1) {
      const day = start + i * dayStep
      if (day > cap) break
      days.push(day)
    }
    return days.length ? days : [start]
  }

  const days = []
  for (let day = start; day <= cap; day += dayStep) {
    days.push(day)
  }
  return days.length ? days : [start]
}
